export default "__VITE_ASSET__C_Y3Vqr9__"